import { Divider, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import InfoBlock from '../../components/InfoBlock'
import { CompanyEvents } from './CompanyEvents'
import { SourceTypeButtons } from './SourceTypeButtons'
import { IssueEntity } from 'types/IssueEntity'
import { PRInputListItem, SourceType } from '@finance-lab/utils/types'
import { CompanyEntity } from 'types/CompanyEntity'
import { TransactionType } from '@finance-lab/utils/types'
import { Link } from 'react-router'

export const sortAndSetIssuesFunction = <
    T extends Array<Pick<IssueEntity, 'statusComplete' | 'publicationDate' | 'subEndDate'>>,
>(
    issues: T,
) => {
    if (!issues) return []

    const sortedIssues = issues.sort((a, b) => {
        // First sort by statusComplete (0 before 1)
        if (a.statusComplete !== b.statusComplete) {
            return (a.statusComplete ?? 0) - (b.statusComplete ?? 0)
        }

        // If statusComplete values are the same, sort by date
        const s1 = new Date(a.subEndDate ? a.subEndDate : (a.publicationDate ?? 0))
        const s2 = new Date(b.subEndDate ? b.subEndDate : (b.publicationDate ?? 0))

        return s2.getTime() - s1.getTime() // Newest dates first
    })

    return sortedIssues
}

export const CompanyTargets = ({
    selectedCompany,
    selectedPR,
    onArchivePR,
}: {
    onArchivePR: (pr: Pick<PRInputListItem, 'id'>) => Promise<void>
    selectedCompany: Pick<CompanyEntity, 'id' | 'name'> | null
    selectedPR: Pick<PRInputListItem, 'id'> | null
}) => {
    const [entityType, setEntityType] = useState<TransactionType | null>(null) // Only used for Convertibles at the moment, should be extended for other entity types as well
    const [sourceType, setSourceType] = useState<SourceType | null>(null)

    if (!selectedCompany || !selectedPR) return null
    return (
        <InfoBlock title='Emissioner, teckningsoptioner och konvertibler'>
            <Stack
                direction='row'
                spacing={6}
                sx={{
                    alignItems: 'center',
                }}
            >
                <Typography variant='h6'>{selectedCompany.name}</Typography>
                <Typography variant='body1'>
                    <Link to={`/companies/${selectedCompany.id}`}>[Länk till bolagsvy]</Link>
                </Typography>
            </Stack>
            <Divider sx={{ marginY: 6 }} />
            <SourceTypeButtons
                entityType={entityType}
                selectedSourceType={sourceType}
                setSelectedSourceType={setSourceType}
            />
            <Divider sx={{ marginY: 6 }} />
            <CompanyEvents
                setEntityType={setEntityType}
                sourceType={sourceType}
                setSourceType={setSourceType}
                company={selectedCompany}
                selectedPR={selectedPR}
                onArchivePR={onArchivePR}
            />
        </InfoBlock>
    )
}
